import React, { useState, useEffect, useContext } from "react";
import { Col, Row, List, Button, Image, message, Typography, Tag } from "antd";
import {
  DeleteOutlined,
  EditOutlined,
  PlusSquareOutlined,
} from "@ant-design/icons";
import { faIndianRupeeSign } from "@fortawesome/free-solid-svg-icons";


import {
  DateFormat,
  getApi,
  saveApi,
  successMessage,
} from "../../../../helpers";
import Sidebar from "../../../../components/Sidebar";
import CategoryPopup from "../Popup";
import UploadImage from "../../../../components/UploadImage";
import Popup from "../../../../components/Popup";
import { StoreContext } from "../../../../context";
import { canWrite } from "../../../../helpers/permissions";

const { Title, Text } = Typography;

export default function CategorySidebar({
  visible = false,
  data = {},
  onClose,
  onUploadDone,
  editCategory,
  subCategory = false,
}) {
  const { storeId } = useContext(StoreContext);
  const [loading, setLoading] = useState(false);
  const [list, setList] = useState([]);
  const [selected, setSelected] = useState({});
  const [popup, setPopup] = useState(false);
  const [popupTitle, setPopupTitle] = useState("");
  const [deleteImagePopup, setDeleteImagePopup] = useState("");

  useEffect(() => getList(), []);

  const getList = async () => {
    setLoading(true);
    if (subCategory) {
      const res = await getApi(
        { sub_category_id: data.sub_category_id },
        "getSubCategoryGroup"
      );
      if (res.data && res.data.length) {
        res.data.shift();
        setList(res.data);
      }
    } else {
      const res = await getApi(
        { category_id: data.category_id },
        "getSubCategory"
      );
      if (res.data) setList(res.data);
    }
    setLoading(false);
  };

  const saveHandler = async (values) => {
    setPopup(false);
    setLoading(true);
    let apiName = "createSubCategory";
    let msg = "";
    let payload = { name: values.name, description: values.description };
    if (subCategory) {
      if (selected.sub_category_group_id) {
        apiName = "updateSubCategoryGroup";
        payload = {
          ...payload,
          sub_category_group_id: selected.sub_category_group_id,
        };
      } else {
        apiName = "createSubCategoryGroup";
        payload = {
          ...payload,
          sub_category_id: data.sub_category_id,
          getId: true,
        };
      }
    } else if (selected.sub_category_id) {
      apiName = "updateSubCategory";
      msg = "Updated Sub Category";
      payload = { ...payload, sub_category_id: selected.sub_category_id };
    } else payload = { ...payload, category_id: data.category_id, getId: true };
    const res = await saveApi(payload, msg, apiName);
    if (res.sub_category_id) {
      if (values.sub_category_groups?.length) {
        values.sub_category_groups.map(async (scg) => {
          const resp = await saveApi(
            {
              name: scg.name,
              description: scg.description,
              sub_category_id: res.sub_category_id,
              getId: true,
            },
            "",
            "createSubCategoryGroup"
          );
          if (resp.sub_category_group_id && scg.file?.file?.originFileObj) {
            const fmData = new FormData();
            const headers = { "content-type": "multipart/form-data" };
            fmData.append("sub_category_group_id", resp.sub_category_group_id);
            fmData.append(
              "sub_category_group_img",
              scg.file.file?.originFileObj
            );
            const re = await getApi(
              fmData,
              "uploadSubCategoryGroupImage",
              "ecomm/",
              headers
            );
            if (re.data) console.log(re.data);
            else setLoading(false);
          }
        });
      }
      if (values.file?.file?.originFileObj) {
        const fmData = new FormData();
        const headers = { "content-type": "multipart/form-data" };
        fmData.append("sub_category_id", res.sub_category_id);
        fmData.append("sub_category_img", values.file.file?.originFileObj);
        const re = await getApi(
          fmData,
          "uploadSubCategoryImage",
          "ecomm/",
          headers
        );
        if (re.data) getList();
        else setLoading(false);
      } else getList();
      successMessage("Added Sub Category");
    } else if (res.sub_category_group_id) {
      if (values.file?.file?.originFileObj) {
        const fmData = new FormData();
        const headers = { "content-type": "multipart/form-data" };
        fmData.append("sub_category_group_id", res.sub_category_group_id);
        fmData.append(
          "sub_category_group_img",
          values.file.file?.originFileObj
        );
        const re = await getApi(
          fmData,
          "uploadSubCategoryGroupImage",
          "ecomm/",
          headers
        );
        if (re.data) getList();
        else setLoading(false);
      } else getList();
    } else if (res) getList();
    else setLoading(false);
  };

  const deleteImageHandler = async () => {
    let payload = {
      sub_category_image_id: subCategory ? data.image_id : deleteImagePopup,
    };
    let msg = "Sub Category Image Deleted";
    let apiName = "deleteSubCategoryImage";
    if (deleteImagePopup === "Category" && !subCategory) {
      payload = { category_image_id: data.image_id };
      msg = "Category Image Deleted";
      apiName = "deleteCategoryImage";
    } else if (subCategory && deleteImagePopup !== "Category") {
      payload = { sub_category_group_image_id: deleteImagePopup };
      msg = "Group Image Deleted";
      apiName = "deleteSubCategoryGroupImage";
    }
    setDeleteImagePopup("");
    setLoading(true);
    const res = await saveApi(payload, msg, apiName);
    if (res) {
      deleteImagePopup === "Category" ? onUploadDone() : getList();
    } else setLoading(false);
  };

  return (
    <>
      {deleteImagePopup && (
        <Popup
          saveText="Yes, Delete"
          title={
            "Delete " + deleteImagePopup === "Category"
              ? deleteImagePopup
              : "Sub Category" + " Image"
          }
          saveHandler={deleteImageHandler}
          visible
          cancelHandler={() => setDeleteImagePopup("")}
        >
          <Text strong style={{ fontSize: 18 }}>
            Are you sure to delete the Image ?
          </Text>
          <br />
          <Text type="danger">This action cannot be reverted.</Text>
        </Popup>
      )}
      {popup && (
        <CategoryPopup
          visible
          subCategory={subCategory ? false : true}
          title={popupTitle}
          data={selected}
          cancelHandler={() => setPopup(false)}
          saveHandler={(values) => saveHandler(values)}
          uploadImage={selected.sub_category_id ? false : true}
        />
      )}
      <Sidebar
        title={subCategory ? "Sub Category Details" : "Category Details"}
        visible={visible}
        loading={loading}
        onClose={onClose}
        footer={
          !storeId && canWrite() && (
            <div style={{
              display: 'flex',
              gap: '12px',
              padding: '16px 0'
            }}>
              <Button
                icon={<EditOutlined />}
                onClick={editCategory}
                type="primary"
                size="large"
                style={{
                  width: '100%',
                  height: '48px',
                  borderRadius: '8px'
                }}
              >
                Edit{subCategory ? " Sub" : ""} Category Details
              </Button>
            </div>
          )
        }
      >
        <div style={{ padding: '0 4px' }}>
          {/* Image Section */}
          <div style={{ marginBottom: '16px', backgroundColor: '#F7F7F7', borderRadius: '12px', padding: '12px' }}>
            <div style={{ position: 'relative' }}>
              {data.sub_category_image || data.category_image ? (
                <Image
                  alt="category img"
                  width="100%"
                  height={280}
                  style={{ 
                    borderRadius: '12px',
                    objectFit: 'cover'
                  }}
                  src={data.sub_category_image || data.category_image}
                />
              ) : null}
            </div>

            {/* Upload component */}
            {!storeId && (
              <div style={{ marginTop: '16px' }}>
                {data.sub_category_image || data.category_image ? (
                  <Button
                    onClick={() => setDeleteImagePopup("Category")}
                    danger
                    style={{ borderRadius: '6px' }}
                  >
                    <DeleteOutlined /> Delete Image
                  </Button>
                ) : subCategory ? (
                  <UploadImage
                    onUploadDone={onUploadDone}
                    type_id={data.sub_category_id}
                    setLoading={setLoading}
                    title="Add Sub Category Image"
                    apiName="uploadSubCategoryImage"
                    type="sub_category"
                    style={{ 
                      borderRadius: '12px' 
                    }}
                  />
                ) : (
                  <UploadImage
                    onUploadDone={onUploadDone}
                    type_id={data.category_id}
                    setLoading={setLoading}
                    style={{ 
                      borderRadius: '12px' 
                    }}
                  />
                )}
              </div>
            )}
          </div>

          {/* Title and Status */}
          <div style={{ marginBottom: '12px' }}>
            <div style={{ display: "flex", justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '8px' }}>
              <Title style={{ 
                margin: 0, 
                fontSize: '24px',
                fontWeight: 600,
                lineHeight: 1.2,
                flex: 1
              }} level={3}>
                {data.sub_category_name || data.name}
              </Title>
              <span
                style={{
                  fontSize: '12px',
                  fontWeight: 500,
                  padding: "4px 12px",
                  textTransform: "uppercase",
                  borderRadius: '6px',
                  marginLeft: '12px',
                  backgroundColor: data.is_active === 1 ? '#f6ffed' : '#fff2f0',
                  color: data.is_active === 1 ? '#52c41a' : '#ff4d4f',
                  border: data.is_active === 1 ? '1px solid #b7eb8f' : '1px solid #ffccc7'
                }}
              >
                {data.is_active === 1 ? 'Active' : 'Inactive'}
              </span>
            </div>
            
            <Text type="secondary" style={{ fontSize: '14px' }}>
              Created: {DateFormat(data.created_at)}
            </Text>
          </div>

          {/* Description */}
          {data.description && (
            <div style={{ marginBottom: '16px' }}>
              <Text style={{ fontSize: '16px', fontWeight: 600, display: 'block', marginBottom: '12px' }}>
                Description
              </Text>
              <Text style={{ fontSize: '14px', color: '#666', lineHeight: 1.5 }}>
                {data.description}
              </Text>
            </div>
          )}

          {/* Sub Categories or Groups List */}
          <div style={{ marginBottom: '16px' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '12px' }}>
              <Text style={{ fontSize: '16px', fontWeight: 600 }}>
                {subCategory ? "Groups" : "Sub Categories"}
              </Text>
              {!storeId && (
                <Button
                  onClick={() => (
                    setSelected({}),
                    setPopupTitle(
                      subCategory ? "Add Group" : "Add Sub Category"
                    ),
                    setPopup(true)
                  )}
                  type="primary"
                  icon={<PlusSquareOutlined />}
                  style={{ borderRadius: '6px' }}
                >
                  Add {subCategory ? "Group" : "Sub Category"}
                </Button>
              )}
            </div>
            
            <List
              bordered={false}
              size="small"
              itemLayout="horizontal"
              dataSource={list}
              renderItem={(sub) => (
                <List.Item
                  style={{ 
                    padding: '12px',
                    backgroundColor: 'transparent',
                    borderRadius: '8px',
                    marginBottom: '8px'
                  }}
                >
                  <List.Item.Meta
                    avatar={
                      <div style={{ width: '60px', height: '60px', borderRadius: '8px', overflow: 'hidden' }}>
                        {sub.sub_category_group_image || sub.sub_category_image ? (
                          <Image
                            width={60}
                            height={60}
                            style={{ objectFit: "cover" }}
                            alt="subcategory img"
                            src={sub.sub_category_group_image || sub.sub_category_image}
                            preview={false}
                          />
                        ) : !storeId && (
                          <UploadImage
                            miniBtn
                            onUploadDone={() => getList()}
                            type_id={
                              subCategory
                                ? sub.sub_category_group_id
                                : sub.sub_category_id
                            }
                            setLoading={setLoading}
                            title={
                              "Add " + (subCategory
                                ? "Group"
                                : "Sub Category") + " Image"
                            }
                            apiName={
                              subCategory
                                ? "uploadSubCategoryGroupImage"
                                : "uploadSubCategoryImage"
                            }
                            type={
                              subCategory ? "sub_category_group" : "sub_category"
                            }
                            fileList={
                              sub.sub_category_group_image ||
                              sub.sub_category_image
                                ? [
                                    {
                                      url:
                                        sub.sub_category_group_image ||
                                        sub.sub_category_image,
                                      uid:
                                        "-1" + (subCategory
                                          ? sub.sub_category_group_id
                                          : sub.sub_category_id),
                                      status: "done",
                                      name: "image.png",
                                      image_id: sub.image_id
                                        ? sub.image_id.toString()
                                        : null,
                                    },
                                  ]
                                : []
                            }
                            onRemove={(image) =>
                              setDeleteImagePopup(image.image_id)
                            }
                            done={
                              sub.sub_category_group_image ||
                              sub.sub_category_image ||
                              storeId
                                ? true
                                : false
                            }
                          />
                        )}
                      </div>
                    }
                    title={
                      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <Text strong style={{ fontSize: '16px' }}>
                          {sub.sub_category_group_name || sub.sub_category_name}
                        </Text>
                        {!storeId && canWrite() && (
                          <Button
                            onClick={() => (
                              setPopupTitle(
                                subCategory
                                  ? "Edit Group Details"
                                  : "Edit Sub Category"
                              ),
                              setSelected(sub),
                              setPopup(true)
                            )}
                            type="link"
                            icon={<EditOutlined />}
                          >
                            Edit
                          </Button>
                        )}
                      </div>
                    }
                    description={
                      <div>
                        {sub.description && (
                          <Text style={{ fontSize: '14px', color: '#666', display: 'block' }}>
                            {sub.description}
                          </Text>
                        )}
                        {sub.created_at && (
                          <Text style={{ fontSize: '12px', color: '#999' }}>
                            Created: {DateFormat(sub.created_at)}
                          </Text>
                        )}
                      </div>
                    }
                  />
                </List.Item>
              )}
            />
          </div>
        </div>
      </Sidebar>
    </>
  );
}